"use strict";

import Axios from "axios";
import configuration from "../../configuration";
import SheetDefaultData from '../data/sheet/SheetDefaultData'
import ModuleOneService from '../service/ModuleOneService'
import ModuleTwoService from '../service/ModuleTwoService'
import ModuleThreeService from '../service/ModuleThreeService'
import ModuleFourService from '../service/ModuleFourService'
import ModuleFiveService from '../service/ModuleFiveService'
import ModuleSixService from '../service/ModuleSixService'

const url = configuration.apiHost + "analyticals";

export default class AnalyticalWorksheetService {
  
  static async generateDefault(budget){
    let analyticalWorksheet  = {
      header      : await SheetDefaultData.getHeader(budget),
      moduleOne   : await SheetDefaultData.getModuleOne(),
      moduleTwo   : await SheetDefaultData.getModuleTwo(),
      moduleThree : await SheetDefaultData.getModuleThree(),
      moduleFour  : await SheetDefaultData.getModuleFour(),
      moduleFive  : await SheetDefaultData.getModuleFive(),
      moduleSix   : await SheetDefaultData.getModuleSix()
    }
      
    return analyticalWorksheet
  }
  static async generateModuleFive(){
    return await SheetDefaultData.getModuleFive()
  }
  static async getAll() {
    try {
      let alls = await Axios.get(url);
      return alls.data;
    } catch (error) {
      throw new Error(error);
    }
  }
  static async getBonds(id, attachment){
    if(!id || !attachment)
      return []
    try {
      let bonds = await Axios.get(`${url}/bond/${id}/${attachment}`);
      return bonds.data;
    } catch (error) {
      throw new Error(error);
    }
  }
  static async getById(id) {
    try {
      let sheet = await Axios.get(`${url}/${id}`);
      return sheet.data;
    } catch (error) {
      throw new Error(error);
    }
  } 
  static async save(analyticalWorksheet) {
    try {
      let saved = await Axios.post(url, analyticalWorksheet);
      return saved.data;
    } catch (error) {
      throw new Error(error);
    }
  } // save()
  static async edit(analytical) {
    try {
      let updated = await Axios.put(url, analytical);
      return updated.data;
    } catch (error) {
      throw new Error(error);
    }
  } // edit()
  static async remove(analytical) {
    try {
      await Axios.delete(url, {
        data: analytical
      });
    } catch (error) {
      throw new Error(error);
    }
  } // remove()  
  static async findHeaderByBudgetId(budgetid) {
    try {
      let all = await Axios.get(`${url}/header/${budgetid}`);
      return all.data
    } catch (error) {
      throw new Error(error);
    }
  } // findHeaderByBudgetId()
  static async findByBudgetId(budgetid) {
    try {
      let all = await Axios.get(`${url}/budget/${budgetid}`);
      return all.data
    } catch (error) {
      throw new Error(error);
    }
  } // findHeaderByBudgetId()
  static async updateComputedDataSheet(sheet) {
    try {
      
      return sheet
    } catch (error) {
      throw new Error(error);
    }
  } // findHeaderByBudgetId()

  // Sem necessidade de comunicação com a API

  static async getAmountMonthly(budget, sheet){
    let basicSalaryCCT            = sheet.header.professionalCategory.basicSalary
    let amountOfModuleOne         = await ModuleOneService.getAmountOfModuleOne(sheet.header, sheet.moduleOne)
    let amountOfModuleTwoOne      = await ModuleTwoService.getAmountOfModuleTwoOne(amountOfModuleOne, sheet.moduleTwo)
    let moduleOneAndModuleTwoOne  = amountOfModuleOne + amountOfModuleTwoOne
    let amountOfModuleTwoTwo      = await ModuleTwoService.getAmountOfModuleTwoTwo(moduleOneAndModuleTwoOne, sheet.moduleTwo)
    let amountOfModuleTwoThree    = await ModuleTwoService.getAmountOfModuleTwoThree(basicSalaryCCT, sheet.moduleTwo)
    let amountOfModuleThree       = await ModuleThreeService.getAmountOfModuleThree(moduleOneAndModuleTwoOne, sheet.moduleThree)
    let amountOfModuleFour        = await ModuleFourService.getAmountOfModuleFour(moduleOneAndModuleTwoOne, sheet.moduleFour)
    let amountOfModuleFive        = await ModuleFiveService.getAmountOfModuleFive(sheet._id, sheet.moduleFive)
        
    let subTotal  = amountOfModuleOne +
            amountOfModuleTwoOne +
            amountOfModuleTwoTwo +
            amountOfModuleTwoThree +
            amountOfModuleThree +
            amountOfModuleFour +
            amountOfModuleFive

    let amountOfModuleSix         = await ModuleSixService.getAmountOfModuleSix(budget, sheet.moduleSix, subTotal)

    return subTotal + amountOfModuleSix
  }

} // class



// WEBPACK FOOTER //
// ./src/service/AnalyticalWorksheetService.js